module.exports = __webpack_public_path__ + "static/img/thumb_16.5c27167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_16.png
// module id = uVhP
// module chunks = 0